'use client'

import { useEffect } from 'react'
import adAllianceLib from '@/libs/AdAlliance/AdAlliance.lib'
import AppContext from '@/types/context'
import { useConsentReady } from '@/hooks/useConsentReady'
import { isPurMode } from '@/utils/app/paid'

export default function AdAlliance({ context }: { readonly context: AppContext }) {
  const consentReady = useConsentReady()

  useEffect(() => {
    const purMode = isPurMode()

    const metadata = context.metadata
    const isSportTag =
      metadata?.model?.article?.type === 'article-collection' && metadata?.model?.sectionName === 'Der Sport-Tag'
    if (!purMode && consentReady && !context.metadata?.model.adsDisable) {
      adAllianceLib({
        adZone: isSportTag ? 'sporttag' : 'sport',
        adKeywords: context.metadata?.model.adKeywords ?? [],
        pageType: context.metadata?.model.pageType ?? 'Unknown',
        isWebView: context.webview,
      })
    }
  }, [consentReady])

  return <></>
}
